import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Input, Tag, Select, notification, Tooltip, Pagination, Modal, Form, Switch } from "antd";
import { EditOutlined, DeleteOutlined, } from "@ant-design/icons";
import { changeDocumentTitle } from "../../../utils/title";
import tickerService from "../../../services/ticker-service";

function Tickers() {

    const [loading, setLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [ticker, setTicker] = useState([])
    const [form] = Form.useForm();
    const [editingId, setEditingId] = useState(null);
    const [isModalShow, setIsModalShow] = useState(false)
    const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);

    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });

    const columns = [
        {
            title: "Id",
            dataIndex: 'id',
            key: "id",
        },
        {
            title: "Audience",
            dataIndex: "user_type",
            key: "user_type"
        },
        {
            title: "Messages",
            dataIndex: "message",
            key: "message",
        },
        {
            title: "Status", dataIndex: "is_active", key: "is_active", render: (text, record) =>
                <Tag color={record?.is_active === 1 ? "green" : 'red'}>{record?.is_active === 1 ? "Active" : 'Inactive'}</Tag>
        },
        {
            title: "Actions",
            key: "Actions",
            render: (text, record, { _id }) => (
                <Space size="small">
                    <Tooltip title="Edit" onClick={() => handleEdit(record)}>
                        <EditOutlined />
                    </Tooltip>

                    <Tooltip title="Delete" onClick={() => {
                        setSelectedDeleteRecord(record);
                        setIsModalShow(true);
                    }}>
                        <DeleteOutlined />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            message: values.message,
            user_type: values.user_type,
            role_id: values.user_type === "staff" ? values.role_id : null,
            is_active: values.is_active ? 1 : 0,
        };

        const response = editingId ? await tickerService.update(editingId, payload) : await tickerService.add(payload);
        setLoading(false);
        if (response.success) {
            notification.success({ message: "Success", description: editingId ? "Ticker updated successfully!" : "Ticker added successfully", placement: "topRight" });
            initialize();
            setEditingId(null);
            form.resetFields();
            setIsModalOpen(false);
        } else {
            const errors = response.data?.errors || [response.message];
            notification.error({
                message: "Error",
                description: `Error: ${errors.join(", ")}`,
                placement: "topRight",
            });
        }

    };

    const handleEdit = (record) => {
        form.setFieldsValue({
            message: record.message, // API uses content
            user_type: record.user_type,
            role_id: record.role_id || null,
            is_active: record.is_active === 1,
        });

        setEditingId(record.id);
        setIsModalOpen(true);
    };

    const handleOk = async () => {
        setLoading(true)
        if (!selectedDeleteRecord) return;
        const response = await tickerService.delete(selectedDeleteRecord.id);
        setLoading(false)
        if (response?.success) {
            setTicker((prevData) =>
                prevData.filter((item) => item.id !== selectedDeleteRecord.id)
            );
            initialize();
            notification.success({
                message: "Success",
                description: "Ticker deleted successfully!",
                placement: "topRight",
            });
        } else {
            const errors = response?.data.errors || [response.message];
            notification.error({
                message: "Error",
                description: `Error: ${errors.join(", ")}`,
                placement: "topRight",
            });
        }

        setIsModalShow(false);
    };

    const initialize = async (page = 1, pageSize = pagination.pageSize) => {
        setLoading(true);
        const { success, data, message } = await tickerService.fetch(page, pageSize);
        console.log("data", data)
        setLoading(false);
        if (success) {
            setTicker(data.data);
            setPagination((prev) => ({
                ...prev,
                total: data.total,
                current: page,
                pageSize,
            }));
        } else {
            console.error(`Error fetching vendors: ${message || "Unknown error"}`);
        }
    };

    useEffect(() => {
        changeDocumentTitle("Ticker");
        initialize(pagination.current, pagination.pageSize);
    }, []);

    const deleteModal = (
        <Modal
            title={<div style={{ textAlign: "center" }}>Confirm</div>}
            open={isModalShow}
            onOk={handleOk}
            onCancel={() => setIsModalShow(false)}
            centered
            style={{
                padding: "20px", // Adjust padding for smaller size
            }}
            width={350} // Adjust modal width
            footer={
                <div className="flex justify-center gap-3">
                    <Button type="default"
                        onClick={() => setIsModalShow(false)}
                    >
                        Cancel
                    </Button>
                    <Button type="primary" onClick={handleOk}
                        loading={loading}>
                        Confirm
                    </Button>
                </div>
            }
        >
            <p style={{ textAlign: "center" }}>
                Are you sure you want to delete this?
            </p>
        </Modal>

    )

    const modal = (
        <Modal
            title={editingId ? "Edit Ticker" : "Add New Ticker"}
            open={isModalOpen}
            onCancel={() => {
                setIsModalOpen(false)
                setEditingId(null);
                form.resetFields();
            }}
            width={"700px"}
            footer={null}
        >
            <Form layout="vertical" onFinish={onFinish} form={form}>
                <Row gutter={16}>
                    <Col span={16}>
                        <Form.Item
                            label="User Type"
                            name="user_type"
                            initialValue="customer"
                            rules={[{ required: true }]}
                        >
                            <Select
                                options={[
                                    { label: "Customer", value: "customer" },
                                    { label: "Staff", value: "staff" },
                                    { label: "Login Page", value: "login_page" },
                                ]}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={2}></Col>

                    <Col span={6}>
                        <Form.Item name='is_active' label="Status" valuePropName="checked" initialValue={true} >
                            <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item label="Message" name='message' >
                            <Input.TextArea
                                rows={4}
                                placeholder="Enter Message"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <div className="flex gap-3 justify-end">
                            <Button onClick={() => setIsModalOpen(false)}>
                                Cancel
                            </Button>
                            <Button htmlType="submit" type="primary" loading={loading}>
                                Save
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )

    return (
        <div style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "8px" }}>

            <div className="flex justify-end p-2">
                <Button type="primary" onClick={() => setIsModalOpen(true)}>
                    Add New Ticker Message
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={ticker}
                loading={loading}
                style={{ paddingTop: "10px" }}
                pagination={false}
                footer={() => (
                    <div className="flex justify-between items-center text-xs ">
                        <div className=" text-gray-600">
                            Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                            {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                            {pagination.total} entries
                        </div>
                        <Pagination
                            current={pagination.current}
                            total={pagination.total}
                            pageSize={pagination.pageSize}
                            showSizeChanger={false}
                            onChange={(page) => initialize(page, pagination.pageSize)}
                            itemRender={(current, type, originalElement) => {
                                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                                return originalElement;
                            }}
                        />
                    </div>
                )}
            />
            {modal}
            {deleteModal}
        </div>
    );
}
export default Tickers;
